<template>
  <el-dialog
    append-to-body
    class="middle-dialog"
    :title="$tx('流程提交', 'flowsubmit.message1')"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :visible.sync="dialogVisible"
  >
    <div class="rt-flowsubmit-dialog">
      <h2>
        {{ $tx("选择签核流程", "flowsubmit.message2") }}

        <span>{{
          $tx(
            "(下拉框中可能存在多个可选项目,请注意选择合适的流程)",
            "flowsubmit.message3"
          )
        }}</span>
      </h2>
      <br />
      <div>
        <el-select v-model="selectedFlowId">
          <el-option
            v-for="flow in flowList"
            v-bind:value="flow.new_flowid"
            :key="flow.new_flowid"
            :label="flow.new_name"
          >
          </el-option>
        </el-select>
      </div>
      <br />
      <br />
      <div>
        <h2>
          {{ $tx("选择签核用户", "flowsubmit.message4") }}

          <span>{{
            $tx(
              "(下拉框中可能存在多个可选人员,请注意选择合适的下一级呈递人)",
              "flowsubmit.message5"
            )
          }}</span>
        </h2>
        <template v-if="stepList != null && stepList.length > 0">
          <div v-for="step in stepList" :key="step.new_flowstepsid">
            <br />
            <h3>{{  $tx(
              step.new_name,
              "flowsubmit.message7"
            )  }}</h3>
            <br />
            <el-select v-model="step.selectedUserId">
              <el-option
                v-for="user in step.new_stepusers"
                v-bind:value="user.systemuserid"
                :key="user.systemuserid"
                :label="user.fullname"
              >
              </el-option>
            </el-select>
          </div>
        </template>
        <div
          v-else
          style="
            height: 100px;
            line-height: 100px;
            text-align: center;
            color: #888888;
          "
        >
          {{ $tx("无审批步骤", "flowsubmit.message6") }}
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        v-if="canSubmit"
        @click="submitFlow"
        type="primary"
        :loading="isSubmiting"
        >{{ this.$tx("提交", "common.submit") }}</el-button
      >
      <el-button @click="closeDialog">{{
        this.$tx("关闭", "Btn.Close")
      }}</el-button>
    </div>
  </el-dialog>
</template>


<script>
export default {
  name: "RtFlowSubmitDialog",
  data() {
    return {
      isSubmiting: false,
      dialogVisible: false,
      selectedFlowId: "",
      flowList: [],
      selectedUserId: [],
      stepList: [],
      canSubmit: false,
    };
  },
  props: {
    entityName: {
      type: String,
      require: true,
    },
    entityId: {
      type: String,
      require: true,
    },
    onSuccess: {
      type: Function,
    },
  },
  mounted: function () {
 
  },
  watch: {
    selectedFlowId: function (val) {
      if (rt.isNullOrWhiteSpace(val)) {
        this.stepList = [];
        return;
      }
      rt.get(
        "../api/CrmFlow/GetFlowStepList?flowId=" +
          val +
          "&entityName=" +
          this.entityName +
          "&entityId=" +
          this.entityId
      )
        .then((res) => {
          for (var i in res) {
            if (
              res[i].new_stepusers != null &&
              res[i].new_stepusers.length > 0
            ) {
              res[i].selectedUserId = res[i].new_stepusers[0].systemuserid;
            }
          }
          this.stepList = res;
          this.canSubmit = true;
        })
        .catch((error) => {
          this.canSubmit = false;
          rt.showErrorToast(error);
        });
    },
  },
  methods: {
    UserChang(item) {
      
    },
    getFlowList() {
      var that = this;
      rt.get(
        "../api/CrmFlow/GetFlowList?entityName=" +
          this.entityName +
          "&entityId=" +
          this.entityId
      )
        .then((res) => {
          if (res.length > 0) {
            this.flowList = res;
            this.flowList.forEach(function (params) {
              console.log("params: ",params)
              if(params.new_name == "质保注册审批流程"){
                params.new_name = that.$tx("质保注册审批流程", "flowsubmit.message8")
              }
            })
            this.selectedFlowId = res[0].new_flowid;
          }
          this.$nextTick(()=>{
              var a = document.getElementsByClassName('el-dialog__body');
              [...a].forEach((ele)=>{
                ele.style.minHeight='350px'
              })
              var b = document.getElementsByClassName('el-dialog');
              [...b].forEach((ele)=>{
                ele.style.minHeight='440px'
              })
          })
        })
        .catch((error) => {
          rt.showErrorToast(error);
        });
    },
    submitFlow() {
      if (this.isSubmiting) {
        return;
      }

      var approveList = [];
      this.stepList.map((step) => {
        const user = step.new_stepusers.find(
          (one) => one.systemuserid == step.selectedUserId
        );
        approveList.push({
          StepId: step.new_flowstepsid,
          ApproveUserId: step.selectedUserId,
          ApproveUserLogicalName: user.LogicalName,
        });
      });
      var data = {
        EntityId: this.entityId,
        EntityTypeName: this.entityName,
        FlowId: this.selectedFlowId,
        ApproveList: approveList,
      };
      this.isSubmiting = true;
      console.log(JSON.stringify(data));
      rt.post("../api/CrmFlow/submit", data)
        .then((res) => {
          rt.showSuccessToast(res);
          //   if (this.onSuccess) {
          //     this.onSuccess();
          //   }
          //this.onSuccess();
          this.closeDialog();
          this.isSubmiting = false;
          this.$emit("on-submit");
        })
        .catch((errorMessage) => {
          //   var exceptionIndex = errorMessage.indexOf(
          //     "System.Activities.InvalidWorkflowException:"
          //   );
          //   if (exceptionIndex > 0) {
          //     errorMessage = errorMessage.substring(exceptionIndex + 43);
          //   }

          rt.showErrorToast(errorMessage);
          this.isSubmiting = false;
        });
    },
    handleClose() {
      this.closeDialog();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.flowList = [];
      this.selectedFlowId = "";
    },
    show() {
      this.dialogVisible = true;
      this.getFlowList();
    },
  },
};
</script>

<style scoped>
.rt-flowsubmit-dialog {
  /* min-height: 400px; */
  padding: 20px;
}
.rt-flowsubmit-dialog .el-select {
  width: 100%;
}
.rt-flowsubmit-dialog h2 > span {
  font-size: 12px;
}
.middle-dialog >>> .el-dialog__body{
  height: 350px !important;
}
.middle-dialog .el-dialog .el-dialog__body{
  height: 350px !important;
}
</style>



// WEBPACK FOOTER //
// submit-dialog.vue?a859624a